export default {
  "content": "<g clip-path=\"url(#a)\"><path d=\"M12 0a12 12 0 100 24 12 12 0 000-24zM5 12a1 1 0 11-2 0 9 9 0 019-9 1 1 0 110 2 7 7 0 00-7 7zm12.77-5.36l-3.9 4.68c.084.217.129.447.13.68a2 2 0 11-2-2h.34l3.89-4.67a1.001 1.001 0 011.54 1.28v.03z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};